import { Row, Col, Select, Input, Button } from 'antd';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import { UserOutlined, DeleteOutlined } from '@ant-design/icons';

import { AddsContainer, StyledInput } from './common';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';
import { TableStore, UserStore } from 'stores';
import { clearNumber } from './utils';

const { Option } = Select;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Labor({ deleteSubItem, changeSubItem, item }) {
  const contextValue = useContext(WorkOrderDetailsContext);
  const { shopUsers, shopVendors, loadingVendors } = contextValue;
  const [removing, setRemoving] = useState(false);
  const [localCost, setLocalCost] = useState(String(item.cost ?? ''));
  const [localHours, setLocalHours] = useState(String(item.hours ?? ''));

  const onRemove = () => {
    setRemoving(true);

    setTimeout(() => {
      deleteSubItem();
    }, 300);
  };

  return (
    <AddsContainer>
      <Row>
        <Col style={{ width: 40, textAlign: 'center', marginTop: '20px' }}>
          <UserOutlined style={{ fontSize: '32px' }} />
        </Col>
        <Col style={{ flex: 1, paddingLeft: 5 }}>
          <Row>
            <Col span={11} style={{ borderBottom: '1px solid #d9d9d9' }}>
              Labor/Vendors:
            </Col>
            <Col
              span={2}
              style={{
                paddingRight: '20px',
                borderBottom: '1px solid #d9d9d9',
              }}
            >
              Hours:
            </Col>
            <Col
              span={5}
              style={{
                paddingRight: '20px',
                paddingLeft: '20px',
                borderBottom: '1px solid #d9d9d9',
              }}
            >
              Rate:
            </Col>
            <Col
              span={5}
              style={{ paddingLeft: '20px', borderBottom: '1px solid #d9d9d9' }}
            >
              Amount:
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col span={11}>
              <Select
                style={{ width: '90%' }}
                onChange={(value) => {
                  changeSubItem({
                    id_labour: value,
                    labourTechnician: undefined,
                  });
                }}
                placeholder="Select labor"
                value={(() => {
                  if (
                    item.labourTechnician &&
                    item.labourTechnician.id_technician
                  ) {
                    const match = shopUsers.find(
                      (u) =>
                        u.id === Number(item.labourTechnician.id_technician)
                    );
                    if (match) return match.id;
                  }
                  if (item.id_labour) return item.id_labour;
                  return null;
                })()}
                data-testid="select-labor-dropdown"
              >
                {(shopUsers || []).map((user) => (
                  <Option key={user.id} value={user.id}>
                    {user.name}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col span={2}>
              <StyledInput
                onChange={(e) => {
                  const cleanedValue = clearNumber(e.target.value);
                  setLocalHours(cleanedValue);
                }}
                onBlur={() => {
                  const finalValue = parseFloat(localHours);
                  if (!isNaN(finalValue)) {
                    changeSubItem({
                      hours: finalValue,
                      amount: parseFloat(
                        (parseInt(finalValue || 0) * item.cost).toFixed(2)
                      ),
                    });
                  } else {
                    changeSubItem({
                      hours: 0,
                    });
                  }
                }}
                prefix=""
                value={localHours}
                data-testid="labor-hours-input"
              />
            </Col>
            <Col span={5} style={{ paddingLeft: '20px' }}>
              <StyledInput
                value={localCost}
                onChange={(e) => {
                  const cleanedValue = clearNumber(e.target.value);
                  setLocalCost(cleanedValue);
                }}
                onBlur={() => {
                  const finalValue = parseFloat(localCost);
                  if (!isNaN(finalValue)) {
                    changeSubItem({
                      cost: finalValue,
                      amount: parseFloat((finalValue * item.hours).toFixed(2)),
                    });
                  } else {
                    changeSubItem({
                      cost: 0,
                    });
                  }
                }}
                prefix="$"
                data-testid="labor-rate-input"
              />
            </Col>
            <Col span={5} style={{ paddingLeft: '20px' }}>
              <StyledInput
                prefix="$"
                defaultValue="0.00"
                value={(item.cost * item.hours).toFixed(2)}
                readOnly
                data-testid="labor-amount-input"
              />
            </Col>
            <IconCol span={1}>
              <Button
                icon={<DeleteOutlined />}
                style={{ fontSize: '20px' }}
                type="text"
                danger
                onClick={onRemove}
                loading={removing}
                data-testid="labor-delete-button"
              />
              {/* <DeleteOutlined
                style={{ fontSize: '20px', color: 'red' }}
                onClick={deleteSubItem}
              /> */}
            </IconCol>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col span={23}>
              <Select
                style={{ width: '100%' }}
                onChange={(value) => changeSubItem({ vendor: value })}
                placeholder={
                  loadingVendors ? 'Loading vendors...' : 'Select vendor'
                }
                value={item.vendor || null}
                showSearch
                loading={loadingVendors}
                disabled={loadingVendors}
                notFoundContent={
                  loadingVendors ? 'Loading...' : 'No vendors found'
                }
                filterOption={(input, option) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
                data-testid="select-vendor-dropdown"
              >
                {(shopVendors || []).map((vendor) => (
                  <Option key={vendor.id} value={vendor.id}>
                    {vendor.name}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row style={{ marginTop: '10px' }}>
            <Col span={23}>
              <Input
                onChange={(e) => {
                  const { value } = e.target;
                  changeSubItem({ description: value });
                }}
                placeholder="Enter Description"
                defaultValue={item.description || ''}
                style={{ width: '100%' }}
                data-testid="labor-description-input"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </AddsContainer>
  );
}

export default Labor;
